import { DefaultButton, FocusTrapZone, Layer, Popup, PrimaryButton, Stack, Text } from "@fluentui/react";
import { BreakpointType } from "../../../Common/Container/ContainerFluid";
import { useBreakpoint } from "../../../Common/Container/ContainerStyles";
import { Trans } from "react-i18next";
import { contentContainerStyles, dismissButtonStyles, lgDismissButtonStyles, lgPopupContentStyles, lgSubTitleStyles, lgSuccessButtonStyles, lgTitleStyles, mdDismissButtonStyles, mdPopupContentStyles, mdSubTitleStyles, mdSuccessButtonStyles, mdTitleStyles, popupContainerStyles, popupContentStyles, smDismissButtonStyles, smPopupContentStyles, smSubTitleStyles, smSuccessButtonStyles, smTitleStyles, subTitleStyles, successButtonStyles, titleContainerStyles, titleStyles, xlDismissButtonStyles, xlPopupContentStyles, xlSubTitleStyles, xlSuccessButtonStyles, xlTitleStyles, xxlDismissButtonStyles, xxlPopupContentStyles, xxlSubTitleStyles, xxlSuccessButtonStyles, xxlTitleStyles } from "../Styles/SwitchToProductionDialogStyles";
import { CustomerService } from "../../../../ApplicationCode/Customer/CustomerService";

export interface ISwitchToProductionDialogProps {
    hidden: boolean;
    saveInProgress: boolean;
    onSuccess: () => void;
    onDismiss: () => void;
}

export const SwitchToProductionDialog: React.FC<ISwitchToProductionDialogProps> = (props: ISwitchToProductionDialogProps) => {
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);

    return (
        <>
            {
                props.hidden ?
                    <></>
                :
                    <Layer>
                        <Popup
                            className={popupContainerStyles}
                            role="dialog"
                            aria-modal="true"
                        >
                            <FocusTrapZone>
                                <Stack
                                    className={
                                        isSM ? 
                                            smPopupContentStyles :
                                        isMD ?
                                            mdPopupContentStyles :
                                        isLG ?
                                            lgPopupContentStyles :
                                        isXL ?
                                            xlPopupContentStyles :
                                        isXXL ?
                                            xxlPopupContentStyles 
                                        :
                                            popupContentStyles
                                    }
                                >
                                    <Stack
                                        className={titleContainerStyles}
                                        verticalFill
                                        verticalAlign="space-around"
                                    >
                                        <Text
                                            className={
                                                isSM ? 
                                                    smTitleStyles :
                                                isMD ? 
                                                    mdTitleStyles :
                                                isLG ? 
                                                    lgTitleStyles :
                                                isXL ?
                                                    xlTitleStyles :
                                                isXXL ?
                                                    xxlTitleStyles
                                                :
                                                    titleStyles
                                            }
                                        >
                                            {CustomerService.translate("switchProductionTitle")}
                                        </Text>
                                        <Text
                                            className={
                                                isSM ? 
                                                    smSubTitleStyles :
                                                isMD ? 
                                                    mdSubTitleStyles :
                                                isLG ?
                                                    lgSubTitleStyles :
                                                isXL ?
                                                    xlSubTitleStyles :
                                                isXXL ?
                                                    xxlSubTitleStyles
                                                :
                                                    subTitleStyles
                                            }
                                        >
                                            <Trans
                                                i18nKey="customerCenter:switchProductionDescription"
                                                components={[<strong />, <br/>]}
                                            />
                                        </Text>
                                    </Stack>
                                    <Stack
                                        verticalFill
                                        verticalAlign="end"
                                        className={contentContainerStyles}
                                    >
                                        <Stack
                                            horizontal
                                            horizontalAlign="space-between"
                                        >
                                            <DefaultButton
                                                onClick={() => props.onDismiss()}
                                                disabled={props.saveInProgress}
                                                styles={
                                                    isSM ?
                                                        smDismissButtonStyles :
                                                    isMD ?
                                                        mdDismissButtonStyles :
                                                    isLG ?
                                                        lgDismissButtonStyles :
                                                    isXL ?
                                                        xlDismissButtonStyles :
                                                    isXXL ?
                                                        xxlDismissButtonStyles
                                                    :
                                                        dismissButtonStyles
                                                }
                                            >
                                                {CustomerService.translate("switchProductionNoButton")}
                                            </DefaultButton>
                                            <PrimaryButton
                                                onClick={() => props.onSuccess()}
                                                disabled={props.saveInProgress}
                                                styles={
                                                    isSM ?
                                                        smSuccessButtonStyles :
                                                    isMD ?
                                                        mdSuccessButtonStyles :
                                                    isLG ?
                                                        lgSuccessButtonStyles :
                                                    isXL ?
                                                        xlSuccessButtonStyles :
                                                    isXXL ?
                                                        xxlSuccessButtonStyles
                                                    :
                                                        successButtonStyles
                                                }
                                            >
                                                {CustomerService.translate("switchProductionYesButton")}
                                            </PrimaryButton>
                                        </Stack>
                                    </Stack>
                                </Stack>
                            </FocusTrapZone>
                        </Popup>
                    </Layer>
            }
        </>
    );
};